import { Briefcase, CheckSquare, Zap, Lightbulb, FileText, Calendar, Users, Target } from 'lucide-react';

export const NOTE_TEMPLATES = [
    {
        id: 'meeting-notes',
        title: 'Meeting Notes',
        description: 'Capture decisions and action items from your meetings.',
        icon: Users,
        category: 'Productivity',
        content: `# 📝 Meeting Notes: [Meeting Title]

**Date:** ${new Date().toLocaleDateString()}
**Time:** 
**Location/Link:** 

## 👥 Attendees
- 

## 🎯 Agenda
1. 
2. 
3. 

## 🗣️ Discussion & Key Points
- 

## ✅ Action Items
- [ ] **Task:** [Description] - **Owner:** @name - **Due:** YYYY-MM-DD
- [ ] 

## ❓ Open Questions
- 

## 📌 Other Notes
- 
`
    },
    {
        id: 'project-brief',
        title: 'Project Brief',
        description: 'Outline the goals, scope, and timeline for a new project.',
        icon: Target,
        category: 'Project Management',
        content: `# 🚀 Project Brief: [Project Name]

## 🎯 Project Goal
*What is the primary objective of this project? What problem are we solving?*

## 🗺️ Scope
### In Scope
- 
### Out of Scope
- 

## 👥 Stakeholders
- **Project Lead:** 
- **Team:** 
- **Key Approvers:** 

## 🗓️ Timeline & Milestones
| Milestone | Target Date | Status |
|---|---|---|
| Kick-off | YYYY-MM-DD | ⏳ Pending |
| Design Phase | YYYY-MM-DD | ⏳ Pending |
| Development | YYYY-MM-DD | ⏳ Pending |
| Launch | YYYY-MM-DD | ⏳ Pending |

## 💰 Budget
*Estimated budget and resource allocation.*

## 📈 Success Metrics
*How will we measure the success of this project?*
- 
`
    },
    {
        id: 'daily-standup',
        title: 'Daily Stand-up',
        description: 'A quick way to organize your daily team check-in notes.',
        icon: Calendar,
        category: 'Team Sync',
        content: `# 📅 Daily Stand-up: ${new Date().toLocaleDateString()}

## ✅ What I accomplished yesterday:
- 

## 🚧 What I'm working on today:
- 

## 🛑 Any blockers?
- 

## 💡 Other Notes or Shoutouts
- 
`
    },
    {
        id: 'to-do-list',
        title: 'To-Do List',
        description: 'A simple and effective checklist to track your tasks.',
        icon: CheckSquare,
        category: 'Productivity',
        content: `# ✅ To-Do List

##  urgent & Important
- [ ] 
- [ ] 

## Important, Not Urgent
- [ ] 
- [ ] 

## Urgent, Not Important
- [ ] 
- [ ] 

## Later
- [ ] 
- [ ] 
`
    },
    {
        id: 'brainstorming-session',
        title: 'Brainstorming Session',
        description: 'Capture and organize ideas during a creative session.',
        icon: Lightbulb,
        category: 'Creative',
        content: `# 💡 Brainstorming: [Topic]

## 🎯 Central Idea/Problem
*Clearly state the core concept or question.*

## 🧠 Stream of Consciousness
*Dump all ideas here, no filter!*
- 
- 
- 

## 🗂️ Categorized Ideas
### Category A:
- 
### Category B:
- 

## ✨ Top 3 Ideas
1. **Idea:** 
   - *Pros:* 
   - *Cons:* 
2. **Idea:** 
   - *Pros:* 
   - *Cons:* 
3. **Idea:** 
   - *Pros:* 
   - *Cons:* 

## 🚀 Next Steps
- 
`
    },
    {
        id: 'new-feature-spec',
        title: 'Feature Spec',
        description: 'Define the requirements for a new product feature.',
        icon: Zap,
        category: 'Project Management',
        content: `# ✨ Feature Spec: [Feature Name]

## 1. Problem Statement
*What user problem are we solving? Why is this important?*

## 2. Proposed Solution
*A high-level overview of the feature and how it addresses the problem.*

## 3. User Stories / Requirements
- As a [user type], I want to [action] so that [benefit].
- 
- 

## 4. Design & UX
*Link to Figma mockups, wireframes, or describe the user flow.*
- [Link to Designs]()

## 5. Technical Considerations
*Any known technical constraints, dependencies, or API requirements?*
- 

## 6. Success Criteria
*What metrics will indicate this feature is successful?*
- 
`
    }
];
